import { createI18n } from '@trippath/shared';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router';

import { App } from './App';
import '../styles/app.scss';
import { registerWorker } from './offline';
import { applyTheme, savedTheme } from './theme';

registerWorker(navigator, import.meta.env.PROD);
applyTheme(savedTheme());

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <I18nextProvider i18n={createI18n()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nextProvider>
    </StrictMode>,
  );
}
